module.exports = __webpack_public_path__ + "whitestretch.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitestretch.png
// module id = 904
// module chunks = 0